module.exports = __webpack_public_path__ + "static/FL2-78ede8295cb6f9511977190fd37160c6.png";